import React, { Component } from "react";
import ForgotPassword from "../components/ForgotPassword";
import { languages } from "../constants/languages";

class ForgotPasswordContainer extends Component {
  state = {
    email: "",
    errorMessage: "",
    sent: false,
    buttonDisabled: false
  };

  handleEmailChange = event => {
    this.setState({ email: event.target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ buttonDisabled: true, errorMessage: "" });
    if (this.state.sent === false) {
      window.firebase
        .auth()
        .sendPasswordResetEmail(this.state.email)
        .then(
          function() {
            this.setState({ sent: true });
          }.bind(this)
        )
        .catch(
          function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            if (errorCode === "auth/invalid-email") {
              errorMessage = languages.login.invalidEmail;
            } else if (errorCode === "auth/user-not-found") {
              errorMessage = languages.login.userNotFound;
            }
            this.setState({
              errorMessage: errorMessage,
              buttonDisabled: false
            });
          }.bind(this)
        );
    }
  };

  generateProps = () => ({
    ...this.state,
    handleEmailChange: this.handleEmailChange,
    handleSubmit: this.handleSubmit
  });

  render() {
    const props = this.generateProps();
    return <ForgotPassword {...props} />;
  }
}

export default ForgotPasswordContainer;
